import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EndPointApi } from '@helpers/endpointapi';

@Injectable({
    providedIn: 'root',
})
export class SimulatorService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async startSimualtor() {
        if (!EndPointApi.isRunningLocal()) return;
        return lastValueFrom(this.http.post(`${this.domain}/api/simulator/start`, null, { headers: this.headers }));
    }
}
